<div class="mobile-menubar">
  <tm-registered-components-renderer [config]="config" area="mobile-menu-bottom"></tm-registered-components-renderer>
</div>
